import React, { createContext, useContext, useEffect, useState } from "react";
import { authAPI } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from Emergent OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("smm_token");
    if (token) {
      authAPI.me()
        .then(({ user }) => setUser(user))
        .catch(() => {
          localStorage.removeItem("smm_token");
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginWithToken = (userData, token) => {
    localStorage.setItem("smm_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("smm_token");
    setUser(null);
  };

  const refreshMe = async () => {
    try {
      const { user: u } = await authAPI.me();
      setUser(u);
      return u;
    } catch (e) {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginWithToken, logout, setUser, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
